export const getNormalizedPrice = (price: number | string): string => `${Number(price).toLocaleString('ru-RU')} ₽`